"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetDashboardQuery = exports.dashboardApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var statsBaseQuery_1 = require("../../utils/statsBaseQuery");
exports.dashboardApi = (0, react_1.createApi)({
    reducerPath: "dashboardApi",
    baseQuery: (0, statsBaseQuery_1.statsBaseQuery)("orderApi", process.env.STATS_ORDER_API, process.env.STATS_API_TOKEN),
    tagTypes: ["dashboard"],
    endpoints: function (builder) { return ({
        getDashboard: builder.query({
            query: function (_a) {
                var region = _a.region, period = _a.period;
                return ({ region: region, url: "/v2/client/dashboard?period=".concat(encodeURIComponent(period)) });
            },
            transformResponse: function (response) { return response.content; },
            providesTags: ["dashboard"],
        }),
    }); },
});
exports.useGetDashboardQuery = exports.dashboardApi.useGetDashboardQuery;
